export const altoQueryKeys = {
  _base: () => ["alto"],
  all: (agencyId: string) => [...altoQueryKeys._base(), { agencyId }],
  branches: (agencyId: string) => [...altoQueryKeys.all(agencyId), "branches"],
};
